import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, map, Observable } from "rxjs";
import { AgentConfig } from "../agent-builder-model/agent-config";
import { HTTPService } from "src/app/services/http.service";
import { StringUtils } from "src/app/system-utils/utils/StringUtils";
import { LogEntry } from "../agent-builder-mcp-log/agent-builder-mcp-log.component";

export interface Agent extends AgentConfig {
  _id?: string;
  createdAt?: Date;
  updatedAt?: Date;
}

@Injectable({ providedIn: 'root' })
export class AgentServicev2 {
  private agentsSubject = new BehaviorSubject<Agent[]>([]);
  public agents$ = this.agentsSubject.asObservable();

  constructor(private http: HTTPService
  ) {
    
  }


  loadLlmModels(): Observable<any[]> {
    let body = {
        "entityName": "Mktpllmmodels",
        "useMongoManual": true,
        "type":"mongo",
        "maxRows":100,
        "sql": StringUtils.stringifyMongoCondition({active:true})
    }

    return this.http.postGeneric<any[]>(body, "JsonBrokerServices/findnative", false, true);
  }


    getMCPLogs(agent: Agent, filters: any[], pageIndex: number, pageSize: number, sortField: string | null, sortOrder: string | null): Observable<{ data: LogEntry[], total: number }> {
        let filter = StringUtils.transformMongoCondigion(filters);

        if (agent && agent.mcps && agent.mcps.length > 0) {
            let filterIdhook = agent.mcps.filter(d => d.idhook?.key>0);
            if ( filterIdhook.length>0){
                //filter = { ...filter, IDHOOK: { $in: filterIdhook.map(d => [...d.idhook.key]) } };
                filter = { ...filter, IDHOOK: { $in: filterIdhook.map(d => d.idhook.key) } };
            }else{
                filter = { ...filter, IDHOOK: -1 }; 
            }
        }else{
            return new Observable(observer => {
                observer.next({ data: [], total: 0 });
                observer.complete();
            });
        }

        let body = {
            "entityName": "Mktpwebhooklog",
            "useMongoManual": true,
            "type":"mongo",
            "sql": StringUtils.stringifyMongoCondition(filter),
            "fetchSize": pageIndex,
            "maxRows": pageSize,
            "sort":sortField ? { [sortField]: sortOrder === 'ascend' ? 1 : -1 } : null
        };

        return this.http.postGeneric<{ data: LogEntry[], total: number }>(body, "JsonBrokerServices/findnative", false, true);
    }   


    getLogMessageDetail(agent: Agent, sessionId: string): Observable<{ data: LogEntry[], total: number }> {
        let filter = { sessionId: sessionId };

        let body = {
            "entityName": agent.qaTable,
            "useMongoManual": true,
            "type":"mongo",
            "dbName":agent.dbName,
            "sql": StringUtils.stringifyMongoCondition(filter)
        };

        return this.http.postGeneric<{ data: LogEntry[], total: number }>(body, "JsonBrokerServices/findnative", false, true);
    }

    
    getLogMessage(agent: Agent, filters: any[], pageIndex: number, pageSize: number, sortField: string | null, sortOrder: string | null): Observable<{ data: LogEntry[], total: number }> {
        let filter = StringUtils.transformMongoCondigion(filters);
      

        let body = {
            "entityName": agent.qaTable,
            "useMongoManual": true,
            "type":"mongo",
            "maxRows": pageSize,
            "fetchSize": pageIndex,
            "mongoType":"aggregation",
            "dbName":agent.dbName,
            "sql":[
                        {
                        $group: {
                        _id: "$sessionId",
                        totalRounds: { $count: {} },
                        totalMessages: {
                            $sum: { $size: { $ifNull: ["$messages", []] } }
                        },
                        totalPromptToken: {
                            $sum: { $sum: "$messages.promptToken" }
                        },
                        totalCompletionTokens: {
                            $sum: { $sum: "$messages.completionTokens" }
                        },
                        totalTokens: {
                            $sum: { $sum: "$messages.totalTokens" }
                        },
                        dataHoraInicial:{
                            $min:"$createdAt"
                        },
                        dataHoraFinal:{
                            $max:"$createdAt"
                        }
                        }
                    },
                    {
                        $project: {
                        _id:0,
                        sessionId:"$_id",
                        totalRounds:1,
                        totalMessages:1,
                        totalPromptToken:1,
                        totalCompletionTokens:1,
                        totalTokens:1,
                        dataHoraInicial:1,
                        dataHoraFinal:1
                        }
                    },
                    {
                        $sort: sortField ? { [sortField]: sortOrder === 'ascend' ? 1 : -1 } : {"dataHoraInicial": -1}
                    },
                    {
                        $match: filter
                    }
                ]
        };

        return this.http.postGeneric<{ data: LogEntry[], total: number }>(body, "JsonBrokerServices/findnative", false, true);
    }   

    

    loadAgents(): void {

        let body = {
            "entityName": "Mktpagents",
            "useMongo": true
        }

        this.http.postGeneric<Agent[]>(body, "JsonBrokerServices/find",false,true).subscribe({
        next: (data:any) => {
            this.agentsSubject.next(data['Mktpagents'] || []);
        },
        error: (err) => {
            console.error('Erro ao carregar agentes:', err);
            this.agentsSubject.next([]);
        }
        });
}

    getAgents(): Agent[] {
        return this.agentsSubject.value;
    }

    getAgentById(id: string): Observable<Agent> {
        let body = {
            "entityName": "Mktpagents",
            "useMongo": true,
            "condition:": `_id=toobjectid('${id}')`
        }

        return this.http.postGeneric<Agent[]>(body, "JsonBrokerServices/find",false,true).pipe(
        map(agents => agents[0]) // Retorna o primeiro agente encontrado
        );
    }

    createAgent(agent: Agent): Observable<Agent> {

        let body = {
            "entityName": "Mktpagents",
            "useMongo": true,
            ...agent
        }
        return this.http.postGeneric<Agent[]>(body, "JsonBrokerServices/save",false,true).pipe(
        map(agents => agents[0]) // Retorna o primeiro agente encontrado
        ); 
    }

    getToolsMcp(url:string, header:Record<string,string>, agent:Agent){ 

        return new Promise((resolve,reject)=>{
            let body = {
                url:url,
                header:JSON.stringify(header),
                agent:agent._id
            }
            
            this.http.post(body, "AiServices/getMcpTools", false, true, false, false).subscribe({
                next: (data) => {
                    resolve(data);
                },
                error: (err) => {
                    console.error('Erro ao buscar ferramentas:', err);
                    reject(err);
                }
            });
        });
    }

    updateAgent(id: string, agent: Agent): Observable<Agent> {
    


        let body = {
            "entityName": "Mktpagents",
            "useMongo": true,
            ...agent,
            condition: `_id='${id}'`
        }
        return this.http.postGeneric<Agent[]>(body, "JsonBrokerServices/save",false,true).pipe(
        map(agents => agents[0]) // Retorna o primeiro agente encontrado
        );
    }

    deleteAgent(id: string): Observable<void> {
        let body = {
            "entityName": "Mktpagents",
            "useMongo": true,
            condition: `_id=toobjectid('${id}')`
        }
        return this.http.postGeneric<Agent[]>(body, "JsonBrokerServices/remove",false,true).pipe(
        map(() => {}) // Retorna vazio
        );
    }

    refreshAgents(): void {
        this.loadAgents();
    }


    createDatabase(template: any): Observable<any> {
        let body = {
            "entityName": "Mktpmongodatabases",
            "useMongo": true,
            ...template
        }
        return this.http.postGeneric<any>(body, "MongoServices/createDatabase", false, true);
    }



    
}
